import { Stack, Tab, Tabs } from "@mui/material"
import { NavLink, useLocation } from "react-router-dom"
import { TabsStyle } from "./style"

export const SocialOrdersTabs = () => {
    const location = useLocation()
    const pathname = location.pathname
    const currentTab = pathname.endsWith('/subscriptions') ? 1 : pathname.endsWith('/mine') ? 2 : 0

    return (
        <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2}>
            <Tabs
                value={currentTab}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={TabsStyle}
            >
                <Tab label="Все" component={NavLink} to="" end />
                <Tab label="Подписки" component={NavLink} to="subscriptions" />
                <Tab label="Мои" component={NavLink} to="mine" />
            </Tabs>
        </Stack>
    )
}